import {
  ArrowCircleLeftIcon,
  BellIcon,
  QuestionIcon,
  TableIcon,
} from '@phosphor-icons/react';
import { Icon } from '@sr/ui-library';
import { Navbar } from 'react-daisyui';
import {
  EXTERNAL_LINKS,
  PROFILE_ROUTES,
  STAFF_ROUTES,
} from '../../constant/routes';
import { useCurrentUserAuth } from '../../hooks/useCurrentUserAuth';
import { isInternalUser } from '../../utils/helpers/common';
import AppSidebarMenu from './AppSidebarMenu';
import { NotificationsNavGate } from './NotificationsNavGate';

const ProfileSubMenu = () => {
  const { currentUser } = useCurrentUserAuth();

  let rootUrl = '/dashboard';

  if (isInternalUser(currentUser)) {
    rootUrl = STAFF_ROUTES.dashboard;
  }

  return (
    <Navbar className="flex-col p-0">
      <Navbar.Start className="modal-avatar block w-full">
        <AppSidebarMenu.Section>
          <AppSidebarMenu.Item
            label={
              <>
                <div className="flex h-6 w-6 flex-col items-center justify-center gap-3">
                  <Icon
                    className="!h-[15.75px] !w-[18px] flex-shrink-0 text-sr-white"
                    icon={ArrowCircleLeftIcon}
                    size="sm"
                  />
                </div>
                Back to Home
              </>
            }
            linkTo={rootUrl}
          />
          <AppSidebarMenu.Item
            label={
              <>
                <div className="flex h-6 w-6 flex-col items-center justify-center gap-3">
                  <Icon
                    className="!h-[15.75px] !w-[18px] flex-shrink-0 text-sr-white"
                    icon="person"
                    size="sm"
                  />
                </div>
                My Profile
              </>
            }
            linkTo={PROFILE_ROUTES.myProfile}
          />
          <NotificationsNavGate>
            <AppSidebarMenu.Item
              label={
                <>
                  <div className="flex h-6 w-6 flex-col items-center justify-center gap-3">
                    <Icon
                      className="!h-[15.75px] !w-[18px] flex-shrink-0 text-sr-white"
                      icon={BellIcon}
                      size="sm"
                    />
                  </div>
                  Notifications
                </>
              }
              linkTo={PROFILE_ROUTES.notifications}
            />
          </NotificationsNavGate>
          <AppSidebarMenu.Item
            label={
              <>
                <div className="flex h-6 w-6 flex-col items-center justify-center gap-3">
                  <Icon
                    className="!h-[15.75px] !w-[18px] flex-shrink-0 text-sr-white"
                    icon={QuestionIcon}
                    size="sm"
                  />
                </div>
                Help
              </>
            }
            linkTo={EXTERNAL_LINKS.helpCentre}
            target="_blank"
          />
          <AppSidebarMenu.Item
            label={
              <>
                <div className="flex h-6 w-6 flex-col items-center justify-center gap-3">
                  <Icon
                    className="!h-[15.75px] !w-[18px] flex-shrink-0 text-sr-white"
                    icon={TableIcon}
                    size="sm"
                  />
                </div>
                Terms and Conditions
              </>
            }
            linkTo={PROFILE_ROUTES.terms}
            target="_blank"
          />
          <AppSidebarMenu.Item
            label={
              <>
                <div className="flex h-6 w-6 flex-col items-center justify-center gap-3">
                  <Icon
                    className="!h-[15.75px] !w-[18px] flex-shrink-0 text-sr-white"
                    icon="filmScript"
                    size="sm"
                  />
                </div>
                Membership Agreement
              </>
            }
            linkTo={EXTERNAL_LINKS.membershipAgreement}
            target="_blank"
          />
        </AppSidebarMenu.Section>
      </Navbar.Start>
    </Navbar>
  );
};

export default ProfileSubMenu;
